import { useMemo, useEffect, useState } from "react";

import {
  Box,
  VStack,
  HStack,
  List,
  ListItem,
  Text,
  Avatar,
  Image,
  CircularProgress,
} from "@chakra-ui/react";

import { ReactComponent as ArrowUpIcon } from "assets/svg/arrow-up.svg";
import LeaderIcon from "assets/png/leader.png";

import { useAffiliateLeaderboardMutation } from "services/walletApi";
import take from "lodash/take";
import isEmpty from "lodash/isEmpty";
import orderBy from "lodash/orderBy";
import Emitter from "libs/Emitter";
// import slice from "lodash/slice";

// import HistoryItem from "components/AffiliateItems/HistoryItem";

// import constant from "config/constant";
// import toPrecision from "util/toPrecision";
// import toCoinLocale from "util/toCoinLocale";
// import { toQueryString } from "util/utils";
// import toPrecision from "util/toPrecision";

function ArrowNumber({ value = 4, isLeader = false }) {
  return (
    <VStack>
      <Text fontSize="14px" fontWeight="600">
        {value}
      </Text>
      {!isLeader && <Box mt="0px !important" as={ArrowUpIcon} />}
      {isLeader && (
        <Image boxSize="14px" src={LeaderIcon} mt="0px !important" alt="" />
      )}
    </VStack>
  );
}

function LeaderItem({ rank = 1, name, username, value, ...xprops }) {
  return (
    <VStack {...xprops}>
      <ArrowNumber value={rank} isLeader={rank === 1} />
      <Box
        boxSize={rank === 1 ? "116px" : "84px"}
        borderRadius="100%"
        bgGradient="linear(to-r, #EB0055, #FFFA80)"
        pos="relative"
      >
        <Avatar
          boxSize={rank === 1 ? "108px" : "78px"}
          name={name ?? "mary lu"}
          pos="absolute"
          top="50%"
          left="50%"
          transform="translate(-50%, -50%)"
        />
      </Box>

      <VStack>
        <Text
          fontSize="14px"
          fontWeight="400"
          maxW="80px"
          whiteSpace="nowrap"
          textOverflow="ellipsis"
          overflow="hidden"
        >
          {username ?? "@maryLu"}
        </Text>
        <Text
          color="green.400"
          fontSize="12px"
          fontWeight="600"
          mt="0px !important"
        >
          {value ?? "153"}
        </Text>
      </VStack>
    </VStack>
  );
}

// eslint-disable-next-line
function Leaders({ items }) {
  const third = useMemo(() => (items ?? [])[2], [items]);
  const second = useMemo(() => (items ?? [])[1], [items]);
  const first = useMemo(() => (items ?? [])[0], [items]);

  console.log("ITEMS", first, second, third);

  return (
    <HStack justifyContent="center" pos="relative" minW="260px" minH="200px">
      <LeaderItem
        rank={3}
        pos="absolute"
        bottom="0"
        left="0"
        zIndex="2"
        name={`${third?.firstName} ${third?.lastName}`}
        username={`@${third?.username}`}
        value={third?.referredCount}
      />
      <LeaderItem
        rank={1}
        pos="absolute"
        bottom="0"
        left="50%"
        transform="translateX(-50%)"
        ml="0px !important"
        name={`${first?.firstName} ${first?.lastName}`}
        username={`@${first?.username}`}
        value={first?.referredCount}
      />
      <LeaderItem
        rank={2}
        pos="absolute"
        bottom="0"
        right="0"
        ml="0px !important"
        zIndex="2"
        name={`${second?.firstName} ${second?.lastName}`}
        username={`@${second?.username}`}
        value={second?.referredCount}
      />
    </HStack>
  );
}

function LeaderboardItem(props) {
  const { name, username, rank, value } = props;
  return (
    <ListItem
      bg="#F7F7FC"
      border="1px solid #D9DBE9"
      borderRadius="100px"
      mb="10px"
      p="8px 24px"
    >
      <HStack justifyContent="space-between">
        <HStack>
          <ArrowNumber value={rank ?? 1} />

          <Box
            boxSize="46px"
            borderRadius="100%"
            bgGradient="linear(to-r, #EB0055, #FFFA80)"
            pos="relative"
            ml="12px !important"
          >
            <Avatar
              boxSize="42px"
              name={name ?? "mary lu"}
              pos="absolute"
              top="50%"
              left="50%"
              transform="translate(-50%, -50%)"
            />
          </Box>
          <Text fontSize="12px" fontWeight="400" ml="14px !important">
            {username ?? "@maryLu"}
          </Text>
        </HStack>

        <Text color="green.400" fontWeight="600" fontSize="12px">
          {value ?? "132"}
        </Text>
      </HStack>
    </ListItem>
  );
}

export default function AffiliateLeaderboardReferrerEarners(props) {
  // const { filters } = props;

  const [getLeaderboard, { data, isLoading }] =
    useAffiliateLeaderboardMutation();

  const [dateFilters, setDateFilters] = useState({});

  useEffect(() => {
    Emitter.on("PARTNERS_LEADERBOARD_DATE_FILTER", setDateFilters);

    return () => {
      Emitter.off("PARTNERS_LEADERBOARD_DATE_FILTER", setDateFilters);
    };
  }, []);

  const filters = useMemo(
    () => ({
      limit: 5,
      page: 1,
      sortBy: "referredCount:desc", // referredCount:desc
    }),
    []
  );

  // const queries = useMemo(() => toQueryString(filters ?? {}), [filters]);

  useEffect(() => {
    getLeaderboard({ ...filters, ...dateFilters });
  }, [getLeaderboard, filters, dateFilters]);

  const referrals = useMemo(() => data?.data, [data]);
  const topLeaders = useMemo(
    () => take(orderBy(referrals, ["referredCount"], ["desc"]), 3),
    [referrals]
  );

  const filteredList = useMemo(
    () => orderBy(referrals, ["referredCount"], ["desc"]),
    [referrals]
  );

  //   console.log("List", topLeaders, filteredList);

  return (
    <>
      {!isEmpty(referrals) && referrals?.length > 3 && topLeaders && (
        <VStack w="100%" mb="40px">
          <Leaders items={topLeaders} />
        </VStack>
      )}

      {referrals && (
        <List>
          {filteredList.map((ref, i) => (
            <LeaderboardItem
              name={`${ref?.firstName} ${ref?.lastName}`}
              username={`@${ref?.username}`}
              value={ref?.referredCount}
              key={`leaderboard-item-${i}`}
              rank={i + 1}
            />
          ))}
        </List>
      )}

      <VStack>
        {isLoading && (
          <CircularProgress
            disabled
            isIndeterminate
            color="#a7a7a7"
            size="32px"
          />
        )}

        {!isLoading && isEmpty(referrals) && <Text>History not found</Text>}
      </VStack>
    </>
  );
}
